"use client";

import { type FC } from "react";

import { type IconName } from "./icon-map";
import { variants } from "./variants";

// Define allowed banner styles (customizable in `variants.tsx`)
export type BannerVariant = "1" | "2" | "3" | "4" | "default";

// Props for rendering a banner
export interface BannerProps {
  title: string;
  description: string;
  href: string;
  icon?: IconName;
  variant?: BannerVariant;
}

/**
 * Renders a banner with optional variant styling.
 * Falls back to "default" variant if none provided.
 */
export const Banner: FC<BannerProps> = (props) => {
  const variantKey = props.variant ?? "default";
  const Renderer = variants[variantKey];

  if (!Renderer) {
    // This is a dev-time safeguard: should never occur in prod
    throw new Error(`Unknown banner variant: "${variantKey}"`);
  }

  return <Renderer {...props} />;
};